import { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext();
const KEY = "elitz-cart";
const itemKey = (i) => `${i.slug}__${i.size || ""}__${i.color || ""}`;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const addItem = useCallback((item) => {
    setItems((prev) => {
      const k = itemKey(item);
      const found = prev.find((p) => itemKey(p) === k);
      if (found) return prev.map((p) => (itemKey(p) === k ? { ...p, quantity: p.quantity + item.quantity } : p));
      return [...prev, item];
    });
    setOpen(true);
  }, []);

  const updateQty = useCallback((k, qty) => {
    setItems((prev) => prev.map((p) => (itemKey(p) === k ? { ...p, quantity: Math.max(1, qty) } : p)));
  }, []);

  const removeItem = useCallback((k) => setItems((prev) => prev.filter((p) => itemKey(p) !== k)), []);
  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, count, subtotal, open, setOpen, itemKey }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
export { itemKey };
